module.exports = __webpack_public_path__ + "img/living_room_full.1a2e28fc.jpg";